const MAX = 32;
const MAX_LEN = 256;
let buffer: string[] = [];

export function pushWarning(message: string): void {
  const trimmed = message.length > MAX_LEN ? message.slice(0, MAX_LEN) : message;
  buffer.push(trimmed);
  if (buffer.length > MAX) buffer = buffer.slice(buffer.length - MAX);
}

export function flushWarnings(): string[] {
  const out = buffer;
  buffer = [];
  return out;
}

export function peekWarnings(): readonly string[] {
  return buffer;
}
